import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const getNodeAlignment = TiptapContentResolver.create((_, __, editor) => {
  const node = editor?.state?.selection?.node;
  if (node) {
    return node.attrs?.containerData?.alignment;
  } else {
    return void 0;
  }
});
export {
  getNodeAlignment
};
//# sourceMappingURL=get-node-alignment.js.map
